module.exports = __webpack_public_path__ + "img/tutorial_eight_en.502bc9c3.png";